/**Import react section */
import React, { Fragment } from 'react'
import propTypes from 'prop-types'

/** Material UI import section */
import { Button, DialogContent, Typography } from '@material-ui/core'
import { ButtonCreateStyles } from '../../../resources/styles/ButtonCreateStyles'

/** Custom components import section */
import Dialog from '../../common/Dialog'
import AlertComponent from '../../common/AlertComponent'

/**
 * Confirmation dialog shown before persisting a Work Process Status change.
 * No password confirmation is required for this operation.
 * @param {*} props
 * @returns
 */
const ConfirmWorkProcessStatusUpdateDialog = (props) => {
	const classes = ButtonCreateStyles()
	const { open, onClose, onConfirm, isSaving, ticket, newValueLabel } = props

	/**
	 * Material UI's Dialog renders through a Portal, but React's synthetic events still bubble
	 * through the React component tree (not the DOM tree) — without this, a click anywhere in the
	 * dialog (backdrop, close button, CONFIRM) bubbles up to the grid row's onClick and navigates
	 * to the service detail. Stopping propagation here, as the React ancestor of the portal content,
	 * blocks that bubbling regardless of where in the dialog the click originated.
	 */
	return (
		<div onClick={(event) => event.stopPropagation()}>
			<Dialog
				open={open}
				onClose={onClose}
				isSaving={isSaving}
				header={<strong>Confirm operation</strong>}
				actions={
					<Fragment>
						<Button variant='contained' className={classes.btnSaved} disabled={isSaving} onClick={onConfirm}>
							CONFIRM
						</Button>
					</Fragment>
				}
			>
				<DialogContent>
					<AlertComponent title={'Warning'} message={`This operation changes the Work Process Status value.`} severityType={'warning'} />
					<br />
					<Typography variant='subtitle2'>
						{`Are you sure you want to change the Work Process Status value of ticket ${ticket} to "${newValueLabel}"?`}
					</Typography>
					<br />
				</DialogContent>
			</Dialog>
		</div>
	)
}

ConfirmWorkProcessStatusUpdateDialog.propTypes = {
	/**Determines if the dialog is open */
	open: propTypes.bool,
	/**Handles closing/cancelling the dialog */
	onClose: propTypes.func.isRequired,
	/**Triggers the confirmed Work Process Status change */
	onConfirm: propTypes.func.isRequired,
	/**Determines if the update is currently being saved */
	isSaving: propTypes.bool,
	/**The service ticket number, shown in the confirmation message */
	ticket: propTypes.any,
	/**The label of the Work Process Status value being confirmed */
	newValueLabel: propTypes.string
}

ConfirmWorkProcessStatusUpdateDialog.defaultProps = {
	open: false,
	isSaving: false,
	onClose: () => console.warn('Callback [onClose] no defined'),
	onConfirm: () => console.warn('Callback [onConfirm] no defined')
}

export default ConfirmWorkProcessStatusUpdateDialog
